export function getDistributionQueryVariables({ customerId, surveyId, surveyGroupId, surveyGroup }) {
  return {
    customerId,
    surveyId: surveyId || undefined,
    surveyGroupId: surveyGroupId || surveyGroup?.id || undefined,
  };
}

export function skipDistributionQuery({ surveyId, surveyGroupId }) {
  return !surveyId && !surveyGroupId;
}
